import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { HeroImage } from '@/components/elements/HeroImage';
import { PageSection } from '@/components/elements/PageSection';
import { MainLayout } from '@/components/layouts/MainLayout';
import { ROUTE_PATH } from '@/constants/routes';
import { useUser } from '@/hooks/useUser';

export const Top = () => {
  const { t } = useTranslation();
  const { isSuiteLoungeMember, isAnaLoungeMember } = useUser();

  return (
    <MainLayout pageClassName="p-auth page_a2">
      <PageSection>
        <HeroImage src="/Common_Title.jpg" alt="LOUNGE RESERVATION" />
        <div className="l-grid">
          <section className="l-card">
            <div className="l-card__body">
              <div className="actions">
                <Link
                  to={ROUTE_PATH.RESERVATION}
                  className="link-button link-button--signup-first"
                >
                  {t('top.actions.newReservation')}
                </Link>
                <Link
                  to={ROUTE_PATH.RESERVATION_HISTORY}
                  className="link-button link-button--history"
                >
                  {t('top.actions.reservationHistory')}
                </Link>
              </div>
              <div className="l-text-group l-text-group--white">
                <p className="l-text l-text--note">{t('top.actions.note')}</p>
              </div>
            </div>
          </section>
          <section className="l-card">
            <div className="l-card__body">
              <div className="l-lounge">
                <div className="l-lounge__desc" lang={t('common.lang')}>
                  {t('top.info.loungeDescription1')}
                </div>
                <div className="l-lounge__logos">
                  {isSuiteLoungeMember && (
                    <div className="l-lounge__logo">
                      <img
                        className="l-lounge__logo__image l-lounge__logo__image--suite"
                        src="/Common_ANASUITELOUNGE.png"
                        alt="ANA SUITE LOUNGE"
                      />
                    </div>
                  )}
                  <div className="l-lounge__logo">
                    <img
                      className="l-lounge__logo__image l-lounge__logo__image--ana"
                      src="/Common_ANALOUNGE.png"
                      alt="ANA LOUNGE"
                    />
                  </div>
                </div>
                <div className="l-lounge__desc" lang={t('common.lang')}>
                  {t('top.info.loungeDescription2')}
                </div>
              </div>
              <div className="l-text-group l-text-group--white">
                <p className="l-text">
                  {isAnaLoungeMember
                    ? t('top.info.eligibilityAnaLounge')
                    : t('top.info.eligibilitySuiteLounge')}
                </p>
              </div>
            </div>
          </section>
        </div>
      </PageSection>
    </MainLayout>
  );
};
